import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  textButton: {
    color: colors.primary,
    textTransform: 'uppercase',
    fontSize: fontSize.medium,
    paddingLeft: '9px',
    fontWeight: 'bold',
    letterSpacing: '1.25px',
    paddingTop: '4px',
    justifyContent: 'flex-end',
    '&:hover': {
      color: colors.primary,
    },
    cursor: 'pointer',
  },
}));

const LinkText = ({ href, className = {}, text, ...rest }) => {
  const classes = useStyles();

  return (
    <a {...rest} className={classnames(classes.textButton, className)} href={href} target="_blank">
      {text}
    </a>
  );
};

LinkText.propTypes = {
  href: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
};

export default LinkText;
